import { useState } from 'react';
import { confirmActionT } from '../ReservationDetails';

export const useReservationPopoverState = () => {
  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);
  const [selectedRow, setSelectedRow] = useState<HTMLElement | null>(null);
  const [openEditDatePicker, setOpenEditDatePicker] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState<confirmActionT | null>(null);

  const handleClosePopover = () => {
    setOpenPopover(null);
  };
  const handleOpenCancelConfirmed = () => {
    setOpenConfirm(true);
    setConfirmAction('cancel');
    handleClosePopover();
  };
  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setOpenPopover(event.currentTarget);
  };
  const handleOpenEditDatePicker = () => {
    setConfirmAction('edit');
    setOpenEditDatePicker(true);
  };
  return {
    openPopover,
    handleClosePopover,
    setOpenPopover,
    selectedRow,
    setSelectedRow,
    openEditDatePicker,
    setOpenEditDatePicker,
    openConfirm,
    setOpenConfirm,
    confirmAction,
    setConfirmAction,
    handleOpenCancelConfirmed,
    handleOpenPopover,
    handleOpenEditDatePicker
  };
};
